module.exports = __webpack_public_path__ + "img/3.1911f4f8.jpg";